// Lecture à voix haute pour les enfants qui ne lisent pas encore (readAloud.nl.ts). Version française.
export const readAloudFr = {
    button: 'Lire à voix haute',
    stop: 'Arrêter la lecture',
    task: 'Lire {task} à voix haute',
};
//# sourceMappingURL=readAloud.fr.js.map